import { HandledResponse } from '@/api/generator';
import { useActionWithConfirmation } from '@/components/confirmationModals/useActionWithConfirmation';

type DeleteFunction = (id: string) => Promise<HandledResponse<void>>;

export function useDeleteUnitWithConfirmation(deleteFunction: DeleteFunction) {
  return useActionWithConfirmation({
    confirmedAction: async (id: string) => await deleteFunction(id),
  });
}
